var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pulse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27993 2.25048C8.635 2.26466 8.93138 2.52607 8.9898 2.87659L11.4428 17.5949L13.5289 10.2938C13.6192 9.97767 13.905 9.75721 14.2337 9.75006C14.5625 9.74292 14.8575 9.95076 14.9615 10.2627L16.2906 14.2499H18.128C18.4369 13.376 19.2703 12.7499 20.25 12.7499C21.4926 12.7499 22.5 13.7572 22.5 14.9999C22.5 16.2425 21.4926 17.2499 20.25 17.2499C19.2703 17.2499 18.4369 16.6238 18.128 15.7499H15.75C15.4272 15.7499 15.1406 15.5433 15.0385 15.2371L14.3051 13.037L11.9711 21.2059C11.8748 21.5431 11.5577 21.7685 11.2076 21.7487C10.8575 21.7289 10.5679 21.4691 10.5102 21.1232L8.10303 6.68011L5.97761 15.1818C5.89414 15.5157 5.59415 15.7499 5.25 15.7499H2.25C1.83579 15.7499 1.5 15.4141 1.5 14.9999C1.5 14.5857 1.83579 14.2499 2.25 14.2499H4.66442L7.52239 2.81798C7.60858 2.47324 7.92486 2.2363 8.27993 2.25048ZM20.25 14.2499C19.8358 14.2499 19.5 14.5857 19.5 14.9999C19.5 15.4141 19.8358 15.7499 20.25 15.7499C20.6642 15.7499 21 15.4141 21 14.9999C21 14.5857 20.6642 14.2499 20.25 14.2499Z",
    fill: "#667E87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.5b0ab7d2729f858af55c87018da0a0eb.svg";
export { ForwardRef as ReactComponent };